import { createSelector } from '@reduxjs/toolkit';
import { selectSpecialtyTypes } from 'shared/selectors/jsonQuery';
import { selectSpecialtyTypesOptions } from 'shared/selectors/filters/specialtyTypes/selectSpecialtyTypesOptions';

export const selectSpecialtyTypesAdvancedFilter = createSelector(
  [selectSpecialtyTypes, selectSpecialtyTypesOptions],
  (value, options) => ({
    label: 'Назначение',
    options,
    value: value && value.length > 0 ? value : [null],
  }),
);
